<script setup lang="ts">
import ModalContact from '~/components/pages/results/modals/ModalContact.vue'
import { useResultStore } from '~/store/result'
import { useSubscriberStore } from '~/store/subscriber'
import GetResultsButton from '~/components/pages/results/Header/GetResultsButton.vue'

defineOptions({
	name: 'GetNotified',
})

const subscriberStore = useSubscriberStore()
const resultStore = useResultStore()
const { t: $t } = useI18n()

interface Props {
	lottery?: any
	numbers?: any
	disabled?: boolean
	isAnimating?: boolean
	classBtn?: string
}

const props = withDefaults(defineProps<Props>(), {
	lottery: null,
	numbers: () => ({}),
	disabled: false,
	isAnimating: false,
	classBtn: '',
})

const showModalContact = ref<boolean>(false)
const isActiveAlarms = ref<boolean>(false)

watch(
	() => resultStore.isCompletedActiveAlarms,
	(value) => {
		isActiveAlarms.value = value
	},
	{ immediate: true },
)
</script>

<template>
	<div>
		<UButton
			v-if="isActiveAlarms"
			square
			leading
			color="white"
			variant="soft"
			:label="$t('Alerts are on')"
			:ui="{
				rounded: 'rounded-full',
			}"
			:disabled="props.disabled"
			class="text-neutral-50 font-semibold leading-5 px-5 py-2.5 transition-all duration-300 w-max group"
			:class="{ 'hover:no-underline hover:bg-primary-400': !props.disabled && !subscriberStore.loadingAlerts }"
			:loading="subscriberStore.loadingAlerts"
			@click.stop="showModalContact = true"
		>
			<template #leading>
				<UIcon
					v-if="subscriberStore.loadingAlerts"
					name="i-heroicons:arrow-path-20-solid"
					class="w-5 h-5 text-primary-400 animate-spin"
				/>
				<UIcon
					v-else
					name="i-heroicons-check-circle"
					class="w-6 h-6 text-primary-400"
					:class="{ 'group-hover:text-neutral-50': !props.disabled && !subscriberStore.loadingAlerts }"
				/>
			</template>
		</UButton>
		<GetResultsButton
			v-else
			:is-animating="props.isAnimating"
			:disabled="props.disabled"
			:loading="subscriberStore.loadingAlerts"
			:class-btn="props.classBtn"
			@click="showModalContact = true"
		/>

		<ModalContact
			v-model="showModalContact"
			:prevent-close="false"
			:is-completed-form="resultStore.isCompletedActiveAlarms"
			:is-user-register="isActiveAlarms"
		>
			<p
				v-if="props.lottery !== null"
				class="font-sm sm:text-base text-neutral-800"
			>
				{{
					$t(
						`Enter your email to get free notifications with the latest {lottery} winning numbers after each weekly draw`,
						{
							lottery: props.lottery.label,
						},
					)
				}}.
			</p>
		</ModalContact>
	</div>
</template>
